import { render, staticRenderFns } from "./IQR.vue?vue&type=template&id=36c14cd4&"
import script from "./IQR.vue?vue&type=script&lang=ts&"
export * from "./IQR.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports